import type { AxiosPromise, AxiosInstance } from 'axios'
import axios from 'axios'
import ApiService from './api.service'
import type {
  ClientPortalQuestionnaireSubmissionUpdatePayload,
  CreateQuestionnaireSubmission,
  RequestFormPayload,
  RequestThirdPartyDocumentLink,
  SubmitDocumentPayload
} from '@/types'
const API_URL = import.meta.env.VITE_API_URL

const ClientActionService = {
  retrieveClientActions: (accessToken: string): AxiosPromise => {
    return ApiService.get(
      `/client/portal/cases`,
      {
        headers: {
          'X-Access-Token': accessToken
        }
      },
      'v2'
    )
  },

  retrieveOrganisation: (accessToken: string): AxiosPromise => {
    return ApiService.get(
      `/client/portal/organisation`,
      {
        headers: {
          'X-Access-Token': accessToken
        }
      },
      'v2'
    )
  },

  retrieveClientActionsPreview: (questionnaire_uuid: String): AxiosPromise => {
    return ApiService.get(`/questionnaires/${questionnaire_uuid}/`, {}, 'v3')
  },

  updateSubmission: (
    submissionId: string,
    accessToken: string,
    data: ClientPortalQuestionnaireSubmissionUpdatePayload
  ): AxiosPromise => {
    return ApiService.patch<ClientPortalQuestionnaireSubmissionUpdatePayload>(
      `/client/portal/questionnaires/submission/${submissionId}`,
      data,
      {
        headers: {
          'X-Access-Token': accessToken
        }
      },
      'v2'
    )
  },

  signPdfDocument: (data: SubmitDocumentPayload): AxiosPromise => {
    return ApiService.post('/doc/response/submit', data, {}, 'v2')
  },

  retrievePdfDocument: (data: RequestFormPayload): AxiosPromise => {
    return ApiService.post('/doc/request/form', data, {}, 'v2')
  },

  createQuestionnaireSubmission: (data: CreateQuestionnaireSubmission): AxiosPromise => {
    return ApiService.post('/client/portal/questionnaires/submissions/', data, {}, 'v2')
  },

  createRequestableDocument: (data: RequestThirdPartyDocumentLink): AxiosPromise => {
    return ApiService.post('/doc/third-party/link', data, {}, 'v2')
  },

  retrieveQuestionnaireSubmission: (accessToken: string, submissionId: string): AxiosPromise => {
    return ApiService.get(
      `/client/portal/questionnaires/submission/${submissionId}`,
      {
        headers: {
          'X-Access-Token': accessToken
        }
      },
      'v2'
    )
  },

  retrieveVoiceBotFeedback: (short_id: string): AxiosPromise => {
    const customAxios: AxiosInstance = axios.create({
      baseURL: `${API_URL}v3/` // Set your custom base URL here
    })
    //TODO: Load BASE URL from environment variable
    const apiUrl = `call_user_feedback/${short_id}/`
    return customAxios.get(apiUrl, {})
  },

  updateVoiceBotFeedback: (short_id: string, data: any): AxiosPromise => {
    const customAxios: AxiosInstance = axios.create({
      baseURL: `${API_URL}v3/`
    })

    customAxios.defaults.withCredentials = true
    customAxios.interceptors.request.use((config) => {
      config.headers['X-CSRFTOKEN'] = getCsrfToken()
      return config
    })

    //TODO: Load BASE URL from environment variable
    const apiUrl = `call_user_feedback/${short_id}/`
    return customAxios.put(apiUrl, data)
  }
}

export function getCsrfToken(): string | undefined {
  const value = `; ${document.cookie}`
  const parts = value.split(`; csrftoken=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift()
}

export default ClientActionService
